import PropTypes from 'prop-types'
import React, {PureComponent, Fragment } from 'react'

import { localize } from 'helpers/translator'
import CountdownScreenNumber from 'views/countdown/countdown_screen/number/countdown_screen_number'
import WaitNotificationOverlay from 'views/countdown/countdown_notification/countdown_notification_wait'

class CountdownScreen extends PureComponent {

	timeText = () => {
		const minutes = this.props.remainingMinutes > 0 ?
			` ${this.props.remainingMinutes} ${localize('activity_timer_min')}` :
			''
		const seconds = this.props.remainingSeconds > 0 ?
			` ${this.props.remainingSeconds} ${localize('activity_timer_sec')}` :
			''
		return `${minutes}${seconds}`
	}

	render() {
		return (
			<Fragment>
				{this.props.count === 5 &&
					<WaitNotificationOverlay
						activityName={this.props.activityName}
						remainingMinutes={this.props.remainingMinutes}
						remainingSeconds={this.props.remainingSeconds}
					/>
				}
				{this.props.count === 4 && <CountdownScreenNumber value={'3'} color={'violet'} />}
				{this.props.count === 3 && <CountdownScreenNumber value={'2'} color={'red'} />}
				{this.props.count === 2 && <CountdownScreenNumber value={'1'} color={'yellow'} />}
				{this.props.count === 1 && <CountdownScreenNumber value={localize('matching_pairs_countdown_letsGo')} color={'green'} />}
			</Fragment>)

	}
}

CountdownScreen.defaultProps = {
	count: 5,
	remainingMinutes: 0,
	remainingSeconds: 0,
	activityName: '',
}


CountdownScreen.propTypes = {
	count: PropTypes.number,
	remainingMinutes: PropTypes.number,
	remainingSeconds: PropTypes.number,
	activityName: PropTypes.string,
}

export default CountdownScreen
